import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoCheckbox from '../../components/checkbox/pendo-checkbox.vue.js';

var script = {
  name: 'PendoLegalAcknowledgement',
  components: {
    PendoButton,
    PendoCheckbox,
    PendoInput,
    PendoModal
  },
  props: {
    bodyText: {
      type: String,
      default: ''
    },
    isForCustomer: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Acknowledgement'
    },
    actionButtonType: {
      type: String,
      default: 'primary'
    },
    actionButtonLabel: {
      type: String,
      default: 'Confirm'
    },
    width: {
      type: Number,
      default: 425
    }
  },
  data() {
    return {
      confirmationInput: '',
      isForCustomerChecked: false
    };
  },
  computed: {
    disabledLogic() {
      return this.confirmationInput !== 'I understand' || this.isForCustomer && !this.isForCustomerChecked;
    }
  },
  methods: {
    confirmAction() {
      this.$emit('confirm-action');
      this.reset();
    },
    closeModal() {
      this.$emit('close', false);
      this.reset();
    },
    reset() {
      this.confirmationInput = '';
      this.isForCustomerChecked = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-legal-acknowledgement.vue2.js.map
